// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CustomConfirmModal-confirmationPopupBodyText-a9vWM {
    font-size: 16px;
    line-height: 28px;
    font-weight: 400;
    margin-bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/Common/CustomConfirmModal/CustomConfirmModal.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB","sourcesContent":[".confirmationPopupBodyText {\n    font-size: 16px;\n    line-height: 28px;\n    font-weight: 400;\n    margin-bottom: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"confirmationPopupBodyText": `CustomConfirmModal-confirmationPopupBodyText-a9vWM`
};
module.exports = ___CSS_LOADER_EXPORT___;
